module.exports = __webpack_public_path__ + "static/media/texta.41db7e07.png";